import { useState } from "react";
import { Link } from "react-router-dom";
import { apiErr } from "@/context/AuthContext";
import api from "@/lib/apiClient";
import { GraduationCap, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="h-10 w-10 rounded-lg bg-[#6366F1] flex items-center justify-center">
            <GraduationCap size={22} className="text-white" />
          </div>
          <span className="font-extrabold tracking-tight text-xl text-white">Enjyme</span>
        </Link>
        <div className="bg-white rounded-2xl p-8 border border-slate-200 shadow-xl">
          {sent ? (
            <div className="text-center flex flex-col items-center gap-3" data-testid="forgot-sent-card">
              <MailCheck className="text-[#6366F1]" size={44} />
              <h1 className="font-display font-extrabold text-2xl tracking-tight text-slate-900">Check your email</h1>
              <p className="text-sm text-slate-500">If an account exists for <span className="font-semibold text-slate-700">{email}</span>, we've sent a password reset link. It expires in 1 hour.</p>
              <Link to="/login" className="mt-3 w-full bg-[#6366F1] hover:bg-[#4F46E5] active:scale-[0.98] text-white font-semibold py-2.5 rounded-lg transition-colors">Back to sign in</Link>
            </div>
          ) : (
            <>
              <h1 className="font-display font-extrabold text-2xl tracking-tight text-slate-900">Forgot password</h1>
              <p className="text-sm text-slate-500 mt-1 mb-6">Enter your email and we'll send you a reset link.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-slate-700">Email</label>
                  <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    className="mt-1 w-full px-4 py-2.5 rounded-lg border border-slate-300 text-slate-900 focus:border-[#6366F1] focus:ring-2 focus:ring-[#6366F1]/20 outline-none transition-colors" />
                </div>
                {error && <p data-testid="forgot-error" className="text-sm text-red-600">{error}</p>}
                <button data-testid="forgot-submit" disabled={loading}
                  className="w-full flex items-center justify-center gap-2 bg-[#6366F1] hover:bg-[#4F46E5] active:scale-[0.98] text-white font-semibold py-2.5 rounded-lg transition-colors disabled:opacity-60">
                  {loading && <Loader2 size={16} className="animate-spin" />} Send reset link
                </button>
              </form>
              <p className="text-sm text-slate-500 mt-6 text-center">
                Remembered it? <Link to="/login" className="text-[#6366F1] font-semibold hover:underline">Sign in</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
